import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageEasyService {

  constructor() { }
  
  getLanguage() {
    const language = navigator.language.toLowerCase();
    switch (language) {
      case "pt-br": 
        return "pt-br";
      case "pt":
      case "pt-pt":
        return "pt-pt";
      default: return "pt-br";  
    }
  }
}
